import { ApiService } from './apiService';
import { config } from '../../config/env';

export const apiService = new ApiService({
    baseUrl: config.api.baseUrl,
});

